import axios from 'axios';
import { ComponentType, createContext, useEffect, useState } from 'react';
import { PurchaseAssociationStatus } from '../../components/purchase/AssociationSelection/purchase-association-status.enum';
import { usePathOptions } from '../../hooks';

interface AssociationSelectionProviderValue {
    selectedAssociation: { id: number; associationName: string; imagePath: string; } | null;
    associationStatus: PurchaseAssociationStatus | null;
    setSelectedAssociation: Function;
    setAssociationStatus: Function;
}

interface ChildrenProps {
    children: React.ReactNode;
}

export const AssociationSelectionContext = createContext<AssociationSelectionProviderValue | null>(null)

export const AssociationSelectionProvider: ComponentType<ChildrenProps> = ({ children }) => {

    const pathOptions = usePathOptions();

    const [selectedAssociation, setSelectedAssociation] = useState<{ id: number, imagePath: string, associationName: string } | null>(null)
    const [associationStatus, setAssociationStatus] = useState<PurchaseAssociationStatus | null>(null)

    useEffect(() => {
        if (pathOptions.associationId) getAssociation(pathOptions.associationId)
    }, [pathOptions.associationId]);

    const getAssociation = async (id: string) => {
        try {
            const res = await axios.get(`/api/association/get-approved-association-by-id?id=${id}`)
            setSelectedAssociation(res.data)
            setAssociationStatus(PurchaseAssociationStatus.One)
        } catch (err) { }
    }

    return (
        <AssociationSelectionContext.Provider value={{ selectedAssociation, associationStatus, setSelectedAssociation, setAssociationStatus }}>
            {children}
        </AssociationSelectionContext.Provider>
    )
}